export default "__VITE_ASSET__DIiEzMlp__"